import React from "react";
import { useDispatch } from 'react-redux';

import clsx from "clsx";

import { AppDispatch } from '../../../../redux/reducer/store';

import {
    reducerSingleVacancySalary,
} from "../../../../redux/reducer/recruiting/reducers/reducerSingleVacancy";
import { NumberBlocksProps } from "../../../../types/interfaces";

import styles from "../recruiting.module.scss";

const InputNumber: React.FC<NumberBlocksProps> = ({
    inputValues,
    handleInputChange,
    name,
    title,
    editVacancy,
    data
}) => {
    const dispatch = useDispatch<AppDispatch>();

    const handleChangeNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
        const pos = e.currentTarget.selectionStart;
        const name = e.currentTarget.name;
        if (e.currentTarget.value === '') {
            return;
        }
        if (name === 'salaryExt') {
            if (!/^-?[\d.]*\.?\d{0,2}$/.test(e.currentTarget.value)) {
                return;
            }
        } else {
            if (!/^[\d.]*\.?\d{0,2}$/.test(e.currentTarget.value)) {
                return;
            }
        }
        if (e.currentTarget.value === '.') {
            dispatch(reducerSingleVacancySalary({ [name]: '' }))
        }
        if (e.currentTarget.value.indexOf(".") !== -1) {
            dispatch(reducerSingleVacancySalary({ [name]: e.currentTarget.value.substring(0, e.currentTarget.value.indexOf(".") + 3) }));
        }
        if (e.currentTarget.value.indexOf('.') === -1 && e.currentTarget.value !== '' && e.currentTarget.value !== '-') {
            dispatch(reducerSingleVacancySalary({ [name]: e.currentTarget.value = e.currentTarget.value + '.00' }))
        }
        if (e.currentTarget.value[e.currentTarget.value.length - 1] === '.') {
            dispatch(reducerSingleVacancySalary({ [name]: e.currentTarget.value = e.currentTarget.value + '00' }))
        }
        if (e.currentTarget.value === '.00' || e.currentTarget.value === '-.00') {
            e.currentTarget.value = '';
            dispatch(reducerSingleVacancySalary({ [name]: '' }))
        }
        const parts = e.currentTarget.value.split('.');
        if (parts[1] && parts[1].length > 2) {
            e.currentTarget.value = parts[0] + '.' + parts[1].slice(0, 2);
        }
        e.currentTarget.selectionStart = e.currentTarget.selectionEnd = pos;
        dispatch(reducerSingleVacancySalary({ [name]: e.currentTarget.value }))
        handleInputChange(e);
    };
    const onKeypressHandler = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const name = e.currentTarget.name;
        if (e.currentTarget.value) {
            if ((e.key === 'Delete' || e.key === 'Backspace') && e.currentTarget.value.length <= 1) {
                e.currentTarget.value = '';
                dispatch(reducerSingleVacancySalary({ [name]: '' }));
            }
            if ((e.key === 'Delete' || e.key === 'Backspace') && e.currentTarget.value.length === window.getSelection()!.toString().length) {
                e.currentTarget.value = '';
                dispatch(reducerSingleVacancySalary({ [name]: '' }))
            }
            if (e.key === 'Delete' && (e.currentTarget.selectionEnd !== null && e.currentTarget.selectionEnd >= e.currentTarget.value.length - 3)) {
                e.preventDefault();
            }
            if (e.key === 'Backspace') {
                if (e.currentTarget.selectionEnd === e.currentTarget.value.length - 2) {
                    e.preventDefault();
                    e.currentTarget.selectionEnd = e.currentTarget.value.length - 3;
                } else if (e.currentTarget.selectionEnd === e.currentTarget.value.length - 1) {
                    e.preventDefault();
                    e.currentTarget.value = e.currentTarget.value.slice(0, -2) + "0" + e.currentTarget.value.slice(-1);
                    e.currentTarget.selectionEnd = e.currentTarget.value.length - 2;
                    dispatch(reducerSingleVacancySalary({ [name]: e.currentTarget.value }));
                } else if (e.currentTarget.selectionEnd === e.currentTarget.value.length && e.currentTarget.selectionStart !== 0) {
                    e.preventDefault();
                    e.currentTarget.value = e.currentTarget.value.slice(0, -1) + "0";
                    e.currentTarget.selectionEnd = e.currentTarget.value.length - 1;
                    dispatch(reducerSingleVacancySalary({ [name]: e.currentTarget.value }));
                }
            }
            if (e.key === 'Delete') {
                if (e.currentTarget.selectionEnd === e.currentTarget.value.length - 3) {
                    e.preventDefault();
                    e.currentTarget.selectionStart = e.currentTarget.value.length - 2;
                } else if (e.currentTarget.selectionEnd === e.currentTarget.value.length - 2) {
                    e.preventDefault();
                    e.currentTarget.value = e.currentTarget.value.slice(0, -2) + "0" + e.currentTarget.value.slice(-1);
                    dispatch(reducerSingleVacancySalary({ [name]: e.currentTarget.value }));
                    e.currentTarget.selectionEnd = e.currentTarget.value.length - 1;
                    e.currentTarget.selectionStart = e.currentTarget.value.length - 1;
                } else if (e.currentTarget.selectionEnd === e.currentTarget.value.length - 1) {
                    e.preventDefault();
                    e.currentTarget.value = e.currentTarget.value.slice(0, -1) + "0";
                    dispatch(reducerSingleVacancySalary({ [name]: e.currentTarget.value }));
                    e.currentTarget.selectionEnd = e.currentTarget.value.length;
                    e.currentTarget.selectionStart = e.currentTarget.value.length;
                }
            }
            if ((e.key === '.') && e.currentTarget.selectionEnd === e.currentTarget.value.length - 3) {
                e.currentTarget.selectionStart = e.currentTarget.selectionEnd + 1;
            }
            if ((e.key === '.') && ((e.currentTarget.selectionEnd !== null && e.currentTarget.selectionEnd >= e.currentTarget.value.length - 2) || (e.currentTarget.selectionEnd !== null && e.currentTarget.selectionEnd < e.currentTarget.value.length - 3))) {
                e.preventDefault();
            }
            handleInputChange(e as unknown as React.ChangeEvent<HTMLInputElement>);
        }
    };

    return (
        <div className={clsx(
            styles.subBlock,
            styles.subBlock__right,
            styles.filterInput,
            inputValues.type === 'ON_ROUTE' && styles.notVisible
        )}>
            <input
                value={(inputValues[name] as string) || ''}
                name={name}
                type='text'
                disabled={editVacancy ? inputValues.type === 'ON_ROUTE' : true}
                onChange={handleChangeNumber}
                onKeyDown={onKeypressHandler}
                placeholder=' '
                className={(data && name === 'salaryExt' ? data.salary?.changed : data.revenue?.changed) ? styles.changed : ''}
            />
            <label>{title}</label>
        </div>
    )
}

export default InputNumber;